<template>
    <div>
        <p v-for="error in errors.collect(question.id)" :key="error" class="errorText">
            {{ error }}
        </p>
        <input 
            v-if="question.propertyInfo.type.precision == 'DATE' && question.propertyInfo.key.value == 'basis.geburtsdatum'"
            type="text" 
            v-model="itemValue.value" 
            v-validate="{rules: {'required': question.required, 'date_format': ['DD.MM.YYYY'], 'older_than': [16]}}"    
            :name="question.id" 
            :class="{'error': errors.has(question.id)}"
            :id="question.id">
    </div>
</template>
<script>
    import { Validator } from 'vee-validate';

    Validator.extend('older_than', (value, [age]) => {
        if (value != null) {
            let parts = value.split('.');
            if (parts.length == 3) {
                return (new Date((Number(parts[2]) + Number(age)).toString() + '-' + parts[1] + '-' + parts[0]).getTime() <= Date.now());
            }
        }
        return false;
    });
    
	export default {
		name: 'profileDateTimeEditor',
		props: {
            item: Object,
            question: Object
        },
        inject: ['$validator'],
        data: function() {
            if (this.item.propertyValue == null) {
                this.item.propertyValue = {
                    value: '',
                    type: {
                        kind: 'DATETIME'
                    }
                }
            }
        	return {
                itemValue: this.item.propertyValue
        	}
        },
        watch: {
            itemValue: {
                handler: function(oldValue, newValue) {
                    this.$emit('updateValue', this.question);
                },
                deep: true
            }
        },
        mounted: function() {
            this.$validator.validate('' + this.question.id);
        },
        methods: {
            isUrl: function() {
                return this.question.propertyInfo.key.value.endsWith('.url');
            }
        }
	}
</script>


// WEBPACK FOOTER //
// ProfileDateTimeEditor.vue?d00d7982